import React, {Component} from "react";
import NavBar from "./NavBar";
import CommToolContext from "../common/comm_tool_context";
import {withRouter} from "react-router-dom";
import "./dashboard.css";
class Dashboard extends Component {

  constructor(props) {
    super(props);
    this.state = {
      projecttype: "upcoming"
    }
  }

    render() {
      return (
      <CommToolContext.Consumer>
        {context =>
            (
          <React.Fragment>
            <NavBar   context={context} {...this.props}  />
          </React.Fragment>
        )}
      </CommToolContext.Consumer>
    );
  }
}
Dashboard.contextType = CommToolContext;
export default withRouter(Dashboard);
